import React from 'react';
import { Clock, ShieldCheck, Database } from 'lucide-react';

interface DataFreshnessBadgeProps {
  type?: 'live' | 'tax-year' | 'verified' | 'offline';
  label?: string;
  className?: string;
}

export const DataFreshnessBadge: React.FC<DataFreshnessBadgeProps> = ({
  type = 'live',
  label,
  className = '',
}) => {
  if (type === 'tax-year') {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-[#F3F4F6] text-[#1A1A1A] border border-[#E5E7EB] ${className}`}>
        <ShieldCheck className="w-3.5 h-3.5 text-emerald-600" />
        <span>{label || '2026 Certified Fiscal Rules'}</span>
      </span>
    );
  }

  if (type === 'verified') {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-[#F3F4F6] text-[#1A1A1A] border border-[#E5E7EB] ${className}`}>
        <Database className="w-3.5 h-3.5 text-[#1A1A1A]" />
        <span>{label || 'Mid-Market Wholesale Rate'}</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-[#F3F4F6] text-[#1A1A1A] border border-[#E5E7EB] ${className}`}>
      <Clock className="w-3.5 h-3.5 text-[#6B7280]" />
      <span>{label || 'Updated 2 minutes ago'}</span>
    </span>
  );
};
